import { useLocation, useNavigate } from 'react-router-dom';

import styled, { css, useTheme } from 'styled-components';

import CoreSvg from 'shared/CoreSvg';

import { INavList, nav_list } from './data';

const Snb = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const theme = useTheme();

	const isSelected = (url_arr: string) => location.pathname.includes(url_arr);

	const hanelNavItemClick = (item: INavList) => {
		if (!isSelected(item.url) && item.open) navigate(item.url);
		if (item._onClick && item.open) item._onClick();
	};

	return (
		<SnbWrapper>
			<NavList>
				{nav_list.map((item, idx) => (
					<NavItem
						key={item.name}
						onClick={() => {
							hanelNavItemClick(item);
						}}
						selected={isSelected(item.include)}
					>
						<IconWrapper>
							<CoreSvg
								_fill={item.open ? theme.colors.gray.gray60 : theme.colors.gray.gray15}
							>
								{item.icon}
							</CoreSvg>
						</IconWrapper>

						<NavItemName>{item.name}</NavItemName>
					</NavItem>
				))}
			</NavList>
		</SnbWrapper>
	);
};

const SnbWrapper = styled.nav`
	width: 80px;
	height: 100%;
	padding: 32px 12px;

	border-right: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

const NavList = styled.ul`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 24px;
`;

const NavItem = styled.li<{ selected: boolean }>`
	width: 60px;

	${({ theme }) => theme.typo.body.span_bold};

	${({ theme }) => theme.common.flexBetween};
	flex-direction: column;

	cursor: pointer;

	${({ selected, theme }) =>
		selected &&
		css`
			& > div {
				background-color: ${theme.colors.gray.gray_black};
			}

			& > div > span > svg {
				fill: ${theme.colors.gray.gray_white};
			}
		`}
`;

const IconWrapper = styled.div`
	width: 100%;
	height: 30px;
	border-radius: 16px;
	background-color: transparent;

	${({ theme }) => theme.common.flexCenter};
`;

const NavItemName = styled.span`
	display: block;
	word-break: keep-all;
	text-align: center;
`;
export default Snb;
